import React, { useEffect, useState } from "react";

import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import Menu from "./components/menu"; // Import your menu component
import Home from "./components/home";
import TtdSeva from "./components/ttdSeva";
import ExcelToJSGenerator from "./components/fileUpload";
import CodePaginator from "./components/memberData";
import Header from "./components/header";
import WhatsAppButton from "./components/WhatsAppButton";
import { FaWhatsapp } from "react-icons/fa";
import ContactPage from "./components/ContactPage";
// import GroupSevakForm from "./components/GroupSevakForm";
import SevakListGroup from "./components/SevakListGroup";
import GroupDetailsPage from "./components/GroupDetailsPage";
import GroupWithSevakForm from "./components/AddSevak";
import GroupCodeGenerator from "./components/GroupCodeGenerator";
import TransferMembers from "./components/TransferMember";
import Login from "./components/users/Login";
import Register from "./components/users/Register";
import Dashboard from "./components/users/Dashboard";

import { auth } from "./firebase";
import AgentDashboard from "./components/SevaDashboard";
import CompleteProfile from "./components/users/CompleteProfile";
import SevaDashboard from "./components/SevaDashboard";
import PhoneLogin from "./components/users/register/PhoneLogin";
import CsvToVcard from "./components/csvtovcard";
import GroupCodeGeneratorNew from "./components/GroupCodeGenerator_new";
import TestTTDSevakForm from "./components/TestForm";
import GroupWithSevakFormNew from "./components/AddSevakNew";

console.log("auth.currentUser:", auth.currentUser);

const App = () => {
  const [user, setUser] = useState(null);
  const [authChecked, setAuthChecked] = useState(false); // ✅ new state

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((firebaseUser) => {
      setUser(firebaseUser);
      setAuthChecked(true); // ✅ ensure auth is loaded
    });
    return () => unsubscribe();
  }, []);
  if (!authChecked) {
    return <div className="text-center mt-5">Checking auth...</div>; // or loading spinner
  }

  return (
    <Router>
      <div
        className="d-flex flex-column min-vh-100"
        style={{ backgroundColor: "#FDF1F4" }}
      >
        <Header />
        <Menu user={user} />

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/seva-tickets" element={<TtdSeva />} />
          <Route path="uploadFile" element={<ExcelToJSGenerator />} />
          <Route path="memberdata" element={<CodePaginator />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/grouplist" element={<SevakListGroup />} />
          <Route path="/group/:groupId" element={<GroupDetailsPage />} />
          <Route path="/new" element={<GroupWithSevakForm />} />
          <Route path="/new-sevak" element={<GroupWithSevakFormNew />} />

          <Route path="/groupdatagenerate" element={<GroupCodeGenerator />} />
          <Route path="/groupdatageneratenew" element={<GroupCodeGeneratorNew />} />

          <Route path="/transfer-member" element={<TransferMembers />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/phone-login" element={<PhoneLogin />} />
          <Route path="/csv" element={<CsvToVcard />} />
          <Route path="/testform" element={< TestTTDSevakForm />} />
          <Route
            path="/dashboard"
            element={
              authChecked ? (
                user ? <Dashboard /> : <Navigate to="/login" />
              ) : (
                <div>Checking auth...</div>
              )
            }
          />

          <Route path="/seva-dashboard" element={<SevaDashboard />} />
          <Route path="/complete-profile" element={<CompleteProfile />} />

        </Routes>
        {/* <Footer /> */}
        <WhatsAppButton />
      </div>
    </Router>
  );
};

export default App;

// import React from "react";

// const SearchFrame = () => {
//   return (
//     <div style={{ width: "100%", height: "100vh", border: "none" }}>
//       <iframe
//         src="https://epds.telangana.gov.in/FoodSecurityAct/?wicket:bookmarkablePage=:nic.fsc.foodsecurity.FscSearch"
//         width="100%"
//         height="100%"
//         style={{ border: "none" }}
//         title="FSC Search"
//       ></iframe>
//     </div>
//   );
// };

// export default SearchFrame;
